/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import {
  Grid,
  Skeleton,
  Typography,
  useMediaQuery,
  createTheme,
  //  Link,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  //  Radio,
  // RadioGroup,
  Box,
  Chip,
  Divider,
  Button,
  styled,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { createBreakpoints } from "@mui/system";
import "./AllDeals.css";
//import PriceSlider from "src/component/Filters/PriceFilter";
import { allfilterdata, fetchAndSetRetailers } from "./alldealsfilterdata";
import {
  fetchProductAPIWithFilterFromWP,
  fetchProductSuggestionAPIWithFilterFromWP,
  serviceFetchProductList,
} from "src/api/service/services";
import ProductCardContainer from "./ProductCardContainer";
import { useLocation, useSearchParams } from "react-router-dom";
import { handleSearchfromSharedLibrary } from "src/utils/search_utils";
import { GradientCircularProgress } from "../StyledComponents/StyledLoader/StyledLoader";
import "../Search/Search.css";
import FilterDrawer from "./FilterDrawer";
import { StyledButton } from "../StyledComponents/StyledButton/StyledButton";
import { ExpandMore } from "@mui/icons-material";

type FilterType = {
  // category: string;
  brand: string[];
  //dealsAndDiscount: string;
  retailers: string[];
  // priceRange: string;
  discount: string[];
};

const ProductListing = () => {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("query"); // Retrieve the query parameter
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [queryString, setQueryString] = useState<string>("");

  const location = useLocation();
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [filterLoader, setFilterLoader] = useState<boolean>(false);
  const [isFilterOptionChipDeleted, setIsFilterOptionChipDeleted] =
    useState<boolean>(false);

  const [showTitle, setShowTitle] = useState<boolean>(false);

  const [noProductMessage, setNoProductMessage] = useState<string>("");

  const [cards, setCards] = useState<any>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [rows, setRows] = useState(10); // Set initial rows to 2
  const [limit, setLimit] = useState(12);
  const [offset, setOffset] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [retailersList, setRetailersList] = useState<any>([]);
  const [isAllFiltersCleared, setIsAllFiltersCleared] =
    useState<boolean>(false);
  const [tempSelectedFilters, setTempSelectedFilters] = useState<FilterType>({
    brand: [],
    retailers: [],
    discount: [],
  });

  const clearedFilters = {
    brand: [],
    retailers: [],
    discount: [],
    // Add other filter keys here, if any
  };

  const [selectedFilters, setSelectedFilters] = useState<FilterType>({
    //  category: "",
    brand: [],
    // dealsAndDiscount: "",
    retailers: [],
    //  priceRange: "",
    discount: [],
  });

  const customBreakpoints = createBreakpoints({
    values: {
      xs: 460,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  });

  const theme = createTheme({
    breakpoints: customBreakpoints,
  });
  const isXsScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMdScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isLgScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isXlScreen = useMediaQuery(theme.breakpoints.down("xl"));

  let cardsPerRow = 4;
  if (isXsScreen) {
    cardsPerRow = 2;
  } else if (isSmScreen) {
    cardsPerRow = 2;
  } else if (isMdScreen) {
    cardsPerRow = 3;
  } else if (isLgScreen) {
    cardsPerRow = 4;
  } else if (isXlScreen) {
    cardsPerRow = 5; // or any other value you want for large and xl screens
  }

  const handleSearchRetailers = async (query: string) => {
    setShowLoader(true);
    setCards([]);
    setNoProductMessage("");
    try {
      const searchData = await handleSearchfromSharedLibrary(query);

      if (searchData && searchData.total_items === 0) {
        setNoProductMessage(
          searchData.message?.trim()
            ? searchData.message
            : "No Product Match Found"
        );
      } else {
        setCards(searchData?.data || []);
        setTotalProducts(searchData.total_items);
      }
      setShowLoader(false);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setShowLoader(false); // Hide loader once done
    }
  };

  const fetchRetailers = async () => {
    const retailersList = await fetchAndSetRetailers();
    return retailersList;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resolvedRetailers = await fetchRetailers(); // Wait for the data

        setRetailersList(resolvedRetailers); // Update state with resolved data
      } catch (error) {
        console.error("Error fetching retailers:", error); // Handle errors
      }
    };
    setRetailersList([]);
    fetchData(); // Call the async function
  }, []);

  useEffect(() => {}, [retailersList]);
  useEffect(() => {}, [isAllFiltersCleared]);

  useEffect(() => {}, [cards]);
  useEffect(() => {
    const initialLimit = limit;
    const initialOffset = 0;

    if (location.pathname.includes("search") && searchQuery !== null)
      handleSearchRetailers(searchQuery);
    else {
      fetchProductList(initialLimit, initialOffset);
    }
  }, []);

  // Handle component mount and query changes
  useEffect(() => {
    if (location.pathname.includes("search") && searchQuery !== null) {
      setShowTitle(true);
      setQueryString(searchQuery);
      handleSearchRetailers(searchQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  useEffect(() => {}, [cards]);

  useEffect(() => {
    if (isFilterOptionChipDeleted) {
      onApplyFilters(limit, offset, selectedFilters);
      setIsFilterOptionChipDeleted(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFilterOptionChipDeleted]);

  useEffect(() => {}, [selectedFilters]);

  useEffect(() => {}, [tempSelectedFilters]);

  useEffect(() => {
    setRows(limit / cardsPerRow);
  }, [cardsPerRow, limit, offset]);

  // Fetch product list for default listing
  const fetchProductList = async (limit: number, offset: number) => {
    setShowLoader(true);
    try {
      const response = await serviceFetchProductList(limit, offset);
      setCards(response?.data?.data);
      setTotalProducts(parseInt(response?.data?.total_items, 10) || 0);
    } catch (error: any) {
      console.error("Error:", error.message);
    } finally {
      setShowLoader(false);
    }
  };
  // Type-safe key constraint using keyof FilterType
  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    filterType: keyof FilterType
  ) => {
    const { name, checked } = event.target;

    // For array types, update the value properly
    if (Array.isArray(tempSelectedFilters[filterType])) {
      setTempSelectedFilters((prev) => ({
        ...prev,
        [filterType]: checked
          ? [...(prev[filterType] as string[]), name]
          : (prev[filterType] as string[]).filter((item) => item !== name),
      }));
    }
  };
  /*  const handleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    filterType: string
  ) => {
    const { value } = event.target;
    setSelectedFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  }; */

  const handleDeleteChip = async (
    chipType: keyof FilterType,
    chipValue: string
  ) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [chipType]: Array.isArray(prev[chipType])
        ? (prev[chipType] as string[]).filter((item) => item !== chipValue)
        : "",
    }));
    setIsFilterOptionChipDeleted(true);
  };
  const toggleDrawer =
    (open: boolean | ((prevState: boolean) => boolean)) => () => {
      setDrawerOpen(open);
    };

  const isFilterSelected = (filters: FilterType) => {
    return Object.keys(filters).some((key) => {
      const value = filters[key as keyof FilterType];
      if (Array.isArray(value)) {
        return value.length > 0; // Check if arrays are not empty
      }
      return value !== ""; // Check if other types are not empty strings
    });
  };

  const handleApplyFilter = (newFilters: any) => {
    setTempSelectedFilters(newFilters); // Update state
    onApplyFilters(limit, offset, tempSelectedFilters); // Use the updated value directly
  };

  const onApplyFilters = async (
    limit: number,
    offset: number,
    selectedFilters: any
  ) => {
    if (isFilterOptionChipDeleted) setTempSelectedFilters(selectedFilters);
    else setSelectedFilters(tempSelectedFilters);
    setFilterLoader(true);
    setCards([]);
    setNoProductMessage("");
    setLimit(limit);
    setOffset(offset);
    try {
      if (location.pathname.includes("search") && searchQuery) {
        await fetchProductSuggestionAPIWithFilterFromWP(
          queryString,
          selectedFilters,
          limit,
          offset
        )
          .then((response) => {
            if (response.data.total_items === 0)
              setNoProductMessage("No Product found");
            else {
              setCards(response.data.data || []);
              setTotalProducts(response.data.total_items);
            }
            setShowLoader(false);
          })
          .catch((error) => console.error(error));
      } else if (location.pathname.includes("deals")) {
        await fetchProductAPIWithFilterFromWP(selectedFilters, limit, offset)
          .then((response) => {

            if (response.data.total_items === 0)
              setNoProductMessage("No Product found");
            else {
              setCards(response.data.data || []);
              setTotalProducts(response.data.total_items);
            }
            setShowLoader(false);
          })
          .catch((error) => console.error(error));
      }
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setFilterLoader(false); // Hide loader once done
      setIsAllFiltersCleared(false);
    }
  };
  const getDiscountLabel = (key: string): string => {
    // Find the matching object in allfilterdata.discount
    const matchingDiscount = allfilterdata?.discount.find((d) =>
      Object.keys(d).includes(key)
    );

    // Safely get the value and ensure a string is always returned
    const label = matchingDiscount?.[key as keyof typeof matchingDiscount];
    return label ?? key; // Use key as fallback if label is undefined
  };

  const Content = styled("div")({
    marginTop: "0px", // Adjust content below the header
  });
  // Your filter clearing function
  const handleClearFilters = () => {
    // Update the state
    // setIsAllFiltersCleared(true);
    setIsFilterOptionChipDeleted(true);
    setSelectedFilters(clearedFilters);
    setTempSelectedFilters(clearedFilters);
    //  onApplyFilters(limit, offset, clearedFilters); // Reload data with cleared filters
  };

  return (
    <div>
      <Grid
        container
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        justifyContent={"center"}
      >
        {showTitle && (
          <Grid item xs={12}>
            <Typography
              id="search-section"
              align="left"
              className="title-styles"
              sx={{
                fontSize: {
                  xs: "18px !important",
                  sm: "20px !important",
                  md: "24px !important",
                },
              }}
            >
              Search results for "{searchQuery}"
            </Typography>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sx={{ display: { xs: "block", sm: "none", md: "none" } }}
        >
          {/* Button to open the filter drawer */}
          <Content>
            <Button
              className="filter-button"
              onClick={toggleDrawer(true)}
              sx={{ width: "20%" }}
              endIcon={<ExpandMore />}
            >
              Filters
            </Button>
          </Content>
          <FilterDrawer
            drawerOpen={drawerOpen}
            setDrawerOpen={setDrawerOpen}
            toggleDrawer={toggleDrawer}
            setSelectedFilterOptions={setTempSelectedFilters}
            allFilterData={allfilterdata}
            handleApplyFilter={handleApplyFilter}
          />
        </Grid>

        <Grid
          item
          xs={2.5}
          sx={{ display: { xs: "none", sm: "block", md: "block" } }}
        >
          {isFilterSelected(tempSelectedFilters) && (
            <Grid item xs={12}>
              <Button
                className="clear-filter-button"
                onClick={handleClearFilters}
                sx={{ width: "100%", height: "30px" }}
              >
                Clear all filters
              </Button>
            </Grid>
          )}
          {/*  <Grid item xs={12}>
            <Typography
              id="category-section"
              className="deals-filter-title"
              align="left"
              sx={{
                padding: "0px 30px",
                fontFamily: "Poppins Bold",
                fontSize: "15px",
              }}
            >
              Category
            </Typography>
            <Link
              href="#"
              color="inherit"
              sx={{ fontFamily: "Poppins", fontSize: "12px" }}
            >
              SmartPhones
            </Link>
          </Grid> */}
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend" className="deals-filter-title">
                Brand
              </FormLabel>
              {allfilterdata.brand.map((brand) => (
                <FormControlLabel
                  sx={{ marginLeft: 0 }}
                  key={brand}
                  control={
                    <Checkbox
                      disableRipple
                      disableFocusRipple
                      name={brand}
                      checked={tempSelectedFilters.brand.includes(brand)}
                      onChange={(e) => handleCheckboxChange(e, "brand")}
                      sx={{
                        padding: 0,
                        "& .MuiSvgIcon-root": { fontSize: 18 },
                      }}
                    />
                  }
                  label={brand}
                />
              ))}
            </FormControl>
          </Grid>
          {/*   <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend" className="deals-filter-title">
                Deals & Discounts
              </FormLabel>
              <RadioGroup
                name="dealsAndDiscount"
                value={selectedFilters.dealsAndDiscount}
                onChange={(e) => handleRadioChange(e, "dealsAndDiscount")}
                sx={{ padding: 0, "& .MuiSvgIcon-root": { fontSize: 18 } }}
              >
                {allfilterdata.dealsAndDiscount.map((deal) => (
                  <FormControlLabel
                    sx={{ marginLeft: 0 }}
                    key={deal}
                    value={deal}
                    control={<Radio sx={{ padding: 0 }} />}
                    label={deal}
                  />
                ))}
              </RadioGroup>
            </FormControl>{" "}
          </Grid> */}
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend" className="deals-filter-title">
                Retailers
              </FormLabel>
              {Object.entries(retailersList).map(([key, value]) => (
                <FormControlLabel
                  key={key}
                  sx={{ margin: 0 }}
                  control={
                    <Checkbox
                      disableRipple
                      disableFocusRipple
                      name={key}
                      checked={tempSelectedFilters.retailers.includes(key)}
                      onChange={(e) => handleCheckboxChange(e, "retailers")}
                      sx={{
                        padding: 0,
                        "& .MuiSvgIcon-root": { fontSize: 18 },
                      }}
                    />
                  }
                  label={String(value)} // Explicitly cast to string if value is of type unknown
                />
              ))}
            </FormControl>
          </Grid>
          {/*  <Grid item xs={12}>
            <Typography
              id="category-section"
              className="deals-filter-title"
              align="left"
              sx={{
                fontFamily: "Poppins Bold",
                fontSize: "15px",
              }}
            >
              Price
            </Typography>
            <PriceSlider />
          </Grid> */}
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend" className="deals-filter-title">
                Discount
              </FormLabel>
              {allfilterdata.discount.map((discount) => {
                const [key, value] = Object.entries(discount)[0]; // Extract key and value
                return (
                  <FormControlLabel
                    sx={{ margin: 0 }}
                    key={key} // Use the key as the unique identifier
                    control={
                      <Checkbox
                        disableRipple
                        disableFocusRipple
                        name={key} // Use the key as the name
                        checked={tempSelectedFilters.discount.includes(key)} // Check against the key
                        onChange={(e) => handleCheckboxChange(e, "discount")}
                        sx={{
                          padding: 0,
                          "& .MuiSvgIcon-root": { fontSize: 18 },
                        }}
                      />
                    }
                    label={value} // Use the value as the label
                  />
                );
              })}
            </FormControl>{" "}
          </Grid>
          <Grid item xs={12}>
            <div className="div-apply-button">
              {/* Apply Button */}
              <StyledButton
                //className="apply-button"
                id="apply-button"
                sx={{ marginTop: 2 }}
                onClick={() =>
                  onApplyFilters(limit, offset, tempSelectedFilters)
                }
                disabled={
                  !isFilterSelected(tempSelectedFilters) &&
                  !isFilterSelected(selectedFilters)
                } // Disable if no filters are selected
              >
                Apply
              </StyledButton>
            </div>
          </Grid>
        </Grid>

        <Grid
          item
          xs={0}
          sm={0.5}
          md={0.5}
          sx={{ display: { xs: "none", sm: "block", md: "block" } }}
        >
          <Divider
            orientation="vertical" // Makes it a vertical divider
            flexItem
            sx={{ borderColor: "blue", height: "100%" }} // Customize the color and width
          />
        </Grid>

        <Grid item xs={12} sm={9}>
          <Grid
            item
            xs={12}
            sx={{ display: { xs: "block", sm: "none", md: "none" } }}
          >
            {isFilterSelected(tempSelectedFilters) && (
              <Grid item xs={12}>
                <Button
                  className="clear-filter-button"
                  onClick={handleClearFilters}
                  sx={{
                    width: "100%",
                    height: "30px",
                    justifyContent: "flex-start",
                  }}
                >
                  Clear all filters
                </Button>
              </Grid>
            )}
          </Grid>
          {/*  {isFilterApplied && ( */}
          <Grid item xs={12}>
            <Box
              display="flex"
              flexWrap="wrap"
              gap={1}
              sx={{ paddingBottom: "16px" }}
            >
              {/* Brands */}
              {selectedFilters.brand.length > 0 &&
                selectedFilters.brand.map((brand) => (
                  <Chip
                    key={brand}
                    label={brand}
                    deleteIcon={<ClearIcon fontSize="small" color="inherit" />}
                    onDelete={() => handleDeleteChip("brand", brand)}
                    className="filter-chip-label"
                  />
                ))}

              {/* Deals & Discounts */}
              {/* {selectedFilters.dealsAndDiscount && (
              <Chip
                label={selectedFilters.dealsAndDiscount}
                deleteIcon={<ClearIcon fontSize="small" color="inherit" />}
                onDelete={() =>
                  handleDeleteChip(
                    "dealsAndDiscount",
                    selectedFilters.dealsAndDiscount
                  )
                }
                className="filter-chip-label"
              />
            )} */}

              {/* Retailers */}
              {selectedFilters.retailers.length > 0 &&
                selectedFilters.retailers.map((retailer) => (
                  <Chip
                    key={retailer}
                    deleteIcon={<ClearIcon fontSize="small" color="inherit" />}
                    label={retailer}
                    onDelete={() => handleDeleteChip("retailers", retailer)}
                    className="filter-chip-label"
                  />
                ))}

              {/* Discounts */}
              {selectedFilters.discount.length > 0 &&
                selectedFilters.discount.map((discount) => (
                  <Chip
                    key={discount}
                    label={getDiscountLabel(discount)} // Fetch the label dynamically
                    deleteIcon={<ClearIcon fontSize="small" color="inherit" />}
                    onDelete={() => handleDeleteChip("discount", discount)}
                    className="filter-chip-label"
                  />
                ))}
            </Box>
          </Grid>
          {/*  )} */}
          {showLoader ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="80vh" // Make the container fill the viewport height
            >
              <div className="loader">
                <GradientCircularProgress />
                <Typography sx={{ padding: 2 }}>
                  {showTitle ? "Searching across retailers..." : "Loading..."}
                </Typography>{" "}
              </div>
            </Box>
          ) : noProductMessage ? (
            <div>
              <Typography sx={{ padding: 2 }}>{noProductMessage}</Typography>
            </div>
          ) : filterLoader ? (
            <Grid
              container
              spacing={2}
              sx={{
                flexGrow: 1,
                flexWrap: "wrap",
                justifyContent: "flex-start",
                height: "auto", // Avoid unnecessary stretching
              }}
            >
              {" "}
              {Array.from(new Array(12)).map((_, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  xl={2}
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column", // Adjust based on content
                    height: "auto", // Ensure the height is dynamic
                  }}
                >
                  <Skeleton variant="rounded" height={300} width="100%" />
                </Grid>
              ))}
            </Grid>
          ) : (
            <ProductCardContainer
              dealsData={cards}
              total_items={totalProducts}
              filterArray={selectedFilters}
              searchQuery={queryString}
              setOffset={setOffset}
              isDealsPage={!showTitle}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ProductListing;
